import { useMemo, useState } from 'react';
import { IOpoForList } from '@nkr/models/index';
import { ColDef } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import { CellClickedEvent, FirstDataRenderedEvent, ICellRendererParams, IHeaderParams, SortChangedEvent, ValueGetterParams } from 'ag-grid-community';
import { GridWrapper } from './styles';
import SortableHeaderComponent from '../../center/list/common/sortable-header';
import ActionButtonRenderer from './action-button-renderer';
import { Glyphicon } from 'react-bootstrap';
import { OpoAction } from './opo-action';

interface IProps {
    data: IOpoForList[],
    onItemSelected: (id: number, action: number) => void
}

const Grid = (props: IProps) => {
    const [show, setShow] = useState(false);

    const handleMenuToggle = (show: boolean) => {
        setShow(show);
    };

    const handleItemSelected = (id: any, action: number) => {
        props.onItemSelected(id, action);
    };

    const cols: ColDef[] = [
        {
            colId: 'id',
            field: 'id',
            hide: false,
            width: 50,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>R#</SortableHeaderComponent>,
            valueGetter: (e: ValueGetterParams) => e.node.rowIndex + 1
        },
        {
            colId: 'nkrAlias',
            field: 'nkrAlias',
            width: 200,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Alias</SortableHeaderComponent>
        },
        {
            colId: 'optnAlias',
            field: 'optnAlias',
            width: 200,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>OPTN Alias</SortableHeaderComponent>,
            valueGetter: (e: ValueGetterParams) => {
                let data = e.data as IOpoForList;

                return data.isCenter ? 'N/A' : data.optnAlias;
            }
        },
        {
            colId: 'name',
            field: 'name',
            width: 300,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Name</SortableHeaderComponent>,
            sort: 'asc'
        },
        {
            colId: 'city',
            field: 'city',
            width: 150,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>City</SortableHeaderComponent>
        },
        {
            colId: 'state',
            field: 'state',
            width: 60,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>State</SortableHeaderComponent>
        },
        {
            colId: 'isCenter',
            field: 'isCenter',
            width: 60,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Center</SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IOpoForList;

                if (data.isCenter) {
                    return <Glyphicon glyph='ok' />
                }

                return null;
            }
        },
        {
            colId: 'isActive',
            field: 'isActive',
            width: 60,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Active</SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IOpoForList;

                if (data.isActive) {
                    return <Glyphicon glyph='ok' />
                }

                return null;
            }
        },
        {
            colId: 'hasAch',
            field: 'hasAch',
            width: 75,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Has ACH</SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IOpoForList;

                if (data.hasAch) {
                    return <Glyphicon glyph='ok' style={{ color: 'green' }} />
                }

                return <Glyphicon glyph='remove' style={{ color: 'red' }} />
            }
        },
        {
            colId: 'achApproved',
            field: 'achApproved',
            width: 75,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>ACH Approved</SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IOpoForList;

                if (data.achApproved == true) {
                    return <Glyphicon glyph='ok' style={{ color: 'green' }} />
                }

                return <Glyphicon glyph='remove' style={{ color: 'red' }} />
            }
        },
        {
            colId: 'contactCount',
            field: 'contactCount',
            width: 60,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}># Contacts</SortableHeaderComponent>
        },
        // {
        //     colId: 'portalLink',
        //     width: 75,
        //     headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Portal Link</SortableHeaderComponent>,
        //     cellRendererFramework: (params: ICellRendererParams) => {
        //         let data = params.data as IOpoForList;

        //         return <a href={`/opo-portal/${data.id}`} target='_blank'>OPO Portal</a>;
        //     }
        // },
        {
            colId: 'actions',
            cellClass: 'action-menu',
            width: 75,
            cellRendererParams: { pullRight: true, onMenuToggle: handleMenuToggle, onItemSelected: handleItemSelected },
            cellRendererFramework: ActionButtonRenderer,

        }
    ];

    const columnDefs = useMemo(() => cols, []);
    const rowData = useMemo(() => props.data, [props.data]);

    return (
        <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap' highlight={true}>
            <AgGridReact

                columnDefs={columnDefs}
                defaultColDef={{
                    headerClass: 'list-header',
                    cellClass: 'list-cell',
                    sortable: true
                }}
                rowData={rowData}
                suppressContextMenu={true}
                suppressCellSelection={true}
                onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                onSortChanged={(e: SortChangedEvent) => e.api.refreshCells()}
                onCellClicked={(e: CellClickedEvent) => {
                    let data = e.data as IOpoForList;
                    let colId = e.column.getColId();

                    if (colId != 'actions' && colId != 'portalLink') {
                        props.onItemSelected(data.id, OpoAction.Edit)
                    }
                }}
            />
        </GridWrapper>
    );
}

export default Grid;